module.exports = __webpack_public_path__ + "static/media/ORANGEsvgCheck.3ce5789f.svg";